import React, { FC } from 'react';
import { NewQuoteRequestType } from 'screens/InventoryAccount/inventoryAccount.types';
import Status from './Status';
import BodyItem from './BodyItem';

const NewQuoteRequest: FC<
  Pick<NewQuoteRequestType, 'status' | 'includedServices' | 'locations'>
> = ({ status, includedServices, locations }) => {
  return (
    <div className="flex items-center justify-between">
      <Status status={status} />
      <div className="flex gap-6">
        <BodyItem label="Included services" value={includedServices} />
        <BodyItem label="Locations" value={locations} />
      </div>
    </div>
  );
};

export default NewQuoteRequest;
